import { LinksModelType } from 'core/domain/gateways/model/gateway/gatewayParsed';
import { CustomGatewayDataModel, INITIAL_GATEWAY_STATUS } from '../AssetPage/Tabs/TabGateway/resources/utils';
import { GatewayType } from 'core/domain/gateways/model/gateway/gatewayUnparsed';

export enum GatewayDetailTabType {
  INFO = 'info',
}

export const INITIAL_CUSTOM_GATEWAY: CustomGatewayDataModel = {
  assetId: '',
  aassLastVersion: '',
  assistantCloud: '',
  assistantCloudUrl: '',
  batchId: '',
  batchName: '',
  daemonVersion: '',
  deployedAt: null,
  deploymentDate: null,
  devices: [],
  firmwareVersion: '',
  gatewayVersion: '',
  helperVersion: '',
  hwVersion: '',
  id: '',
  knxVersion: '',
  managementLinks: {
    [LinksModelType.CONTROL_PANEL]: null,
    [LinksModelType.OPENHAB]: null,
    [LinksModelType.SSH_TELEPORT]: null,
  },
  masterUser: '',
  osVersion: '',
  productionDate: 0,
  projectId: '',
  qrCode: '',
  sku: null,
  sensors: null,
  checkedValues: [],
  status: INITIAL_GATEWAY_STATUS,
  type: GatewayType.PRIVATE,
  voiceAssistantUser: '',
  percentValues: [],
  systemConfig: {
    isUpdateButtonDisabled: false,
    isUpdateButtonVisible: true,
    isVersionUpdateError: false,
    isVersionUpdating: false,
    lastVersion: '',
  },
  zwaveVersion: '',
  sharedSensors: null,
  isRebootable: false,
};
